import { Component, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ReportService } from "src/app/core/services/report.service";
import { UserService } from "src/app/core/services/user.service";
import { CommandCenterReport, CommandCenterReportConfiguration } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { ReportCategory } from "src/app/shared/models/enums/report-category.enum";

@Component({
	selector: "app-reports",
	templateUrl: "./reports.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ReportsComponent implements OnInit {
	reports: BehaviorSubject<CommandCenterReport[]> = new BehaviorSubject<CommandCenterReport[]>([]);
	reportCategory: string[] = [];

	filteredReportList: any;

	reportRunning: boolean = false;

	selectedReport: CommandCenterReport;

	constructor(public app: AppService, public reportService: ReportService, private focuslink: FocuslinkService, public userService: UserService) {}

	ngOnInit(): void {
		if (!this.userService.user) {
			this.userService.userSubscription.subscribe(async (data) => {
				this.reportAccessFilter();
			});
		} else {
			this.reportAccessFilter();
		}
		this.reportsGet();
		this.reportService.init();
	}

	async reportsGet() {
		const resp = await this.focuslink.adminCommandCenterReportGet();
		const config = new CommandCenterReportConfiguration(resp);
		this.reportCategory = Array.from(new Set(config.reports.map((i) => i.category))).sort();
		const reports = config.reports.filter((i) => i.accessLevel <= this.userService.user.role);
		this.reports.next(reports);
		console.log(this.reportCategory);
	}

	async init() {}

	async load() {}

	async reportAccessFilter() {
		this.reportList.forEach((r) => {
			if (r.accessLevel > this.userService.user.role) {
				r.optionDisabled = true;
			}
		});
	}

	selectReportCategory(catagory: string) {
		this.filteredReportList = this.reportList.filter((i) => i.category === catagory);
	}

	selectReport(selectedReport) {
		this.reportRunning = true;
	}

	reportCategories = [
		{
			name: "Online Ordering",
			id: ReportCategory.ONLINEORDER,
		},
		{
			name: "System",
			id: ReportCategory.SYSTEM,
		},
	];

	reportList: {
		name: string;
		description: string;
		key: string;
		category: string;
		accessLevel: number;
		optionDisabled: boolean;
	}[] = [
		{
			name: "Future Order Prep",
			description: "Prep report outlining the items that are needed for the selected date range.",
			key: "fc9229e9-04b7-4bce-b4db-199999500910",
			category: ReportCategory.ONLINEORDER,
			accessLevel: 0,
			optionDisabled: false,
		},
		{
			name: "Internet History",
			description: "History of your Focus Systems connection to the internet.",
			key: "8a1b0dee-198b-4bb8-b5d8-8407ad1d5082",
			category: ReportCategory.SYSTEM,
			accessLevel: 0,
			optionDisabled: false,
		},
		{
			name: "Site Visits",
			description: "Report on visits to your Online Ordering site by customers",
			key: "c04f1ccd-0063-49db-9a30-d3047f597cb0",
			category: ReportCategory.ONLINEORDER,
			accessLevel: 0,
			optionDisabled: false,
		},
		{
			name: "Product Use",
			description: "A report on your customers use of our products",
			key: "c04f1ccd-0063-49db-9a30-d3047f597cb0",
			category: ReportCategory.SYSTEM,
			accessLevel: 0,
			optionDisabled: true,
		},
	];
}
